import api from "../../config/client.axios.api";

export const getRevenueMachineRenderMonthApi = async (
  storeId: string,
  monthSelect: any,
) => {
  const response = await api.get(`/history/get-revenue-store-month`, {
    params: {
      storeId,
      moth: monthSelect,
    },
  });
  return response.data;
};
